export const environment = {
  apiUrl: 'https://admin.betazipplex.ca',
  production: true,
  jwtName: 'jwttestadmin',
};
